"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var container_styles_1 = __importDefault(require("../../_helpers/container-styles"));
var spinner_1 = __importDefault(require("../../atoms/spinner"));
var styled_1 = __importStar(require("../../styled"));
var tokens_1 = require("../../tokens");
var table_column_1 = __importDefault(require("./table-column"));
var table_header_1 = __importDefault(require("./table-header"));
exports.tableDefaultComparators = {
    numbers: function (row1, row2, column) { return Number(row1[column.field]) - Number(row2[column.field]); },
    strings: function (row1, row2, column) {
        var r1 = String(row1[column]).toLowerCase();
        var r2 = String(row2[column]).toLowerCase();
        return r1 > r2 ? -1 : r2 > r1 ? 1 : 0;
    }
};
var Table = (function (_super) {
    __extends(Table, _super);
    function Table(props) {
        var _this = _super.call(this, props) || this;
        _this.defaultCellRenderer = function (item, column) { return item[column.field]; };
        _this.defaultOnSort = function (sortOnField, sortDirection) {
            var sortingColumn = _this.getSortingColumn(sortOnField);
            _this.setState({ sortingColumn: sortingColumn, sortDirection: sortDirection });
        };
        _this.sortItems = function (_a) {
            var unsortedItems = _a.unsortedItems, sortingColumn = _a.sortingColumn, sortDirection = _a.sortDirection;
            var items = __spread(unsortedItems);
            if (!sortingColumn || items.length === 0) {
                return items;
            }
            var comparator = _this.getComparator(items, sortingColumn);
            items.sort(function (row1, row2) { return comparator(row1, row2, sortingColumn); });
            if (sortDirection === 'desc') {
                items.reverse();
            }
            return items;
        };
        _this.handleRowClicked = function (item) {
            if (!_this.props.onRowClick) {
                return null;
            }
            return function (evt) {
                _this.props.onRowClick(evt, item);
            };
        };
        if (!props.onSort) {
            _this.state = {
                sortingColumn: _this.getSortingColumn(props.sortOn),
                sortDirection: 'asc'
            };
        }
        return _this;
    }
    Table.prototype.inferColumnsFromChildren = function (children) {
        return React.Children.toArray(children).map(function (element) { return element.props; });
    };
    Table.prototype.getSortingColumn = function (sortOnField) {
        var columns = this.inferColumnsFromChildren(this.props.children);
        if (sortOnField) {
            return columns.find(function (column) { return column.field === sortOnField; });
        }
        else {
            return columns.find(function (column) { return column.sortable; }) || {};
        }
    };
    Table.prototype.getComparator = function (items, sortingColumn) {
        if (sortingColumn.comparator) {
            return sortingColumn.comparator;
        }
        var firstItem = items[0];
        var sampleValue = firstItem[sortingColumn.field];
        if (typeof sampleValue === 'number') {
            return Table.compare.numbers;
        }
        else {
            return Table.compare.strings;
        }
    };
    Table.prototype.render = function () {
        var _this = this;
        var columns = this.inferColumnsFromChildren(this.props.children);
        var sortedItems, sortingColumn, sortDirection, onSort;
        var loading = this.props.loading;
        if (this.props.onSort) {
            onSort = this.props.onSort;
            sortingColumn = this.getSortingColumn(this.props.sortOn);
            sortDirection = this.props.sortDirection;
            sortedItems = this.props.items;
        }
        else {
            onSort = this.defaultOnSort;
            sortingColumn = this.state.sortingColumn;
            sortDirection = this.state.sortDirection;
            sortedItems = this.sortItems({
                unsortedItems: this.props.items,
                sortDirection: sortDirection,
                sortingColumn: sortingColumn
            });
        }
        if (columns[0].children != undefined && columns[0].children.length > 1) {
            var nestedColumns_1 = [];
            columns[0].children.map(function (column) {
                nestedColumns_1.push(column.props);
            });
            columns = nestedColumns_1;
        }
        var rows = sortedItems.map(function (item, index) { return (React.createElement(Table.Row, __assign({ key: "row-" + index, onClick: _this.handleRowClicked(item) }, automation_attribute_1.default('table.row')), columns.map(function (column) {
            var cellRenderer = column.children || _this.defaultCellRenderer;
            return (React.createElement(Table.Cell, { key: column.field, column: column }, cellRenderer(item, column)));
        }))); });
        return (React.createElement(Table.Container, null,
            React.createElement(Table.Element, __assign({}, automation_attribute_1.default('table'), this.props, { rows: rows }),
                React.createElement(Table.Header, { columns: columns, sortingColumn: sortingColumn, sortDirection: sortDirection, onSort: onSort }),
                React.createElement(Table.Body, __assign({}, automation_attribute_1.default('table.body')), rows)),
            React.createElement(Table.EmptyState, { rows: rows, loading: loading }, this.props.emptyMessage),
            React.createElement(Table.LoadingIndicator, { rows: rows, loading: loading })));
    };
    Table.Header = table_header_1.default;
    Table.Column = table_column_1.default;
    Table.compare = exports.tableDefaultComparators;
    Table.Container = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", ";\n    position: relative;\n  "], ["\n    ", ";\n    position: relative;\n  "])), container_styles_1.default);
    Table.Element = styled_1.default.table(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n    border-spacing: 0;\n    border-collapse: collapse;\n    table-layout: fixed;\n    opacity: ", ";\n  "], ["\n    width: 100%;\n    border-spacing: 0;\n    border-collapse: collapse;\n    table-layout: fixed;\n    opacity: ", ";\n  "])), function (p) { return (p.loading && p.rows.length !== 0 ? 0.3 : 1); });
    Table.Body = styled_1.default.tbody(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
    Table.Row = styled_1.default.tr(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    cursor: ", ";\n    &:hover {\n      background-color: ", ";\n    }\n  "], ["\n    cursor: ", ";\n    &:hover {\n      background-color: ", ";\n    }\n  "])), function (props) { return (props.onClick ? 'pointer' : 'inherit'); }, tokens_1.colors.list.backgroundHover);
    Table.Cell = styled_1.default.td(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: ", ";\n    border-top: 1px solid ", ";\n    text-align: left;\n    vertical-align: middle;\n    overflow-wrap: break-word;\n    width: ", ";\n    ", ";\n  "], ["\n    padding: ", ";\n    border-top: 1px solid ", ";\n    text-align: left;\n    vertical-align: middle;\n    overflow-wrap: break-word;\n    width: ", ";\n    ",
        ";\n  "])), tokens_1.spacing.xsmall, tokens_1.colors.base.grayLight, function (props) { return props.column.width || 'auto'; }, function (props) {
        return props.column.truncate
            ? styled_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            overflow-x: hidden;\n          "], ["\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            overflow-x: hidden;\n          "]))) : "";
    });
    Table.defaultProps = {
        onRowClick: null,
        onSort: null,
        sortDirection: 'asc',
        emptyMessage: 'There are no items to display'
    };
    Table.EmptyState = function (_a) {
        var rows = _a.rows, children = _a.children, loading = _a.loading;
        if (rows.length > 0 || !children || loading) {
            return null;
        }
        var TableEmptyState = styled_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      padding: ", ";\n      background-color: rgb(250, 250, 250);\n      border-radius: ", ";\n      text-align: center;\n      margin-top: ", ";\n      color: ", ";\n    "], ["\n      padding: ", ";\n      background-color: rgb(250, 250, 250);\n      border-radius: ", ";\n      text-align: center;\n      margin-top: ", ";\n      color: ", ";\n    "])), tokens_1.spacing.small, tokens_1.misc.radius, tokens_1.spacing.xsmall, tokens_1.colors.text.default);
        return React.createElement(TableEmptyState, null, children);
    };
    Table.LoadingIndicator = function (_a) {
        var loading = _a.loading, rows = _a.rows;
        if (!loading) {
            return null;
        }
        var initialLoadingState = rows.length === 0;
        var TableLoadingIndicator = styled_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      position: ", ";\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: ", ";\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin-top: ", ";\n    "], ["\n      position: ", ";\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: ", ";\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin-top: ", ";\n    "])), initialLoadingState ? 'initial' : 'absolute', initialLoadingState ? 'auto' : '100%', initialLoadingState ? '20px' : '0');
        var SpinnerContainer = styled_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      background-color: white;\n      display: inline-block;\n      padding: ", ";\n      border-radius: 50%;\n    "], ["\n      background-color: white;\n      display: inline-block;\n      padding: ", ";\n      border-radius: 50%;\n    "])), tokens_1.spacing.xsmall);
        return (React.createElement(TableLoadingIndicator, null,
            React.createElement(SpinnerContainer, null,
                React.createElement(spinner_1.default, { size: "medium" }))));
    };
    return Table;
}(React.Component));
exports.default = Table;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=table.js.map